import React from 'react'
import { passThroughAwait, passThrough } from 'promise-passthrough'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import AddBoxIcon from '@material-ui/icons/AddBox'
import { getFormValues } from 'redux-form'
import {
  TABLA_COMUNICACIONES_ACTIVAS,
  TABLA_COMUNICACIONES_INACTIVAS,
  TABLA_COMUNICACIONES_FINALIZADAS,
  TABLA_EXPORTADORES_POR_CARATULA,
  TABLA_COEMS,
  TABLA_COEMS_CERRADOS,
  TABLA_COEMS_FINALIZADOS,
  TABLA_COEMS_ANULADOS,
  TABLA_COMUNICACIONES_HISTORIAL,
  TABLA_COEM_HISTORIAL
} from '../../../config/tables'
import {
  COLUMNS_LISTADO_COMUNICACIONES_ACTIVAS,
  COLUMNS_LISTADO_COMUNICACIONES_INACTIVAS,
  COLUMNS_LISTADO_COMUNICACIONES_FINALIZADAS,
  COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
  COLUMNS_LISTADO_COEMS,
  COLUMNS_LISTADO_COEMS_CERRADOS,
  COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA,
  COLUMNS_HISTORIAL,
  COEM,
  CARATULA,
  REGISTRAR_COEM,
  REGISTRAR_CARATULA,
  RECTIFICAR_COEM,
  RECTIFICAR_CARATULA,
  ANULAR_COEM,
  ELIMINAR_COEM,
  ANULAR_CARATULA,
  CERRAR_COEM,
  SOLICITAR_CAMBIO_BUQUE,
  SOLICITAR_CAMBIO_FECHAS,
  SOLICITAR_ANULACION_COEM,
  SOLICITAR_NO_A_BORDO,
  SOLICITAR_CIERRE_CARGA_GRANEL,
  SOLICITAR_CAMBIO_LOT
} from './constantesComunicacionEmbarque'
import {
  FORM_ADD_CARATULA,
  FORM_COEM_ADD,
  FORM_EDICION_COEM,
  FORM_EDICION_CARATULA
} from '../../../config/forms'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import ComunicacionEmbarque from '../../../models/comunicacionEmbarque/comunicacionEmbarque'
import { Autocomplete } from '../../../models/autocomplete/autocomplete'
import { toast } from 'react-toastify'
import moment from 'moment'
import Giro from '../../../models/giro/giro'
import Buque from '../../../models/buque/buque'
import { parseEntityId } from '../../../models/entity'
import MUIDataTable from '../../MuiTable/MUIDataTable'

export function actualizarDatosCaratulasInactivasParaMuiTable () {
  return (dispatch, getState) => {
    // Comunicaciones inactivas
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COMUNICACIONES_INACTIVAS
    })
    if (state.comunicacionEmbarque.filtroExportador !== null) {
      ComunicacionEmbarque.consultaCaratulasInactivasConExportador(state.comunicacionEmbarque.filtroExportador).then(callback)
    } else {
      ComunicacionEmbarque.getCaratulasInactivas().then(callback)
    }
    async function callback (data) {
      const caratulasExportadores = await ComunicacionEmbarque.listadoExportadorCaratula()
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Detalle de Carátulas Inactivas',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}{<Tooltip title={'Agregar Carátula'}><IconButton onClick={() => dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_CARATULA', estado: true })}><DirectionsBoatIcon /></IconButton></Tooltip>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COMUNICACIONES_INACTIVAS,
          data: data,
          title: `Detalle de Carátulas Inactivas`,
          isLoading: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false,
            pagination: false,
            expandableRows: true,
            expandableRowsOnClick: false,
            expandableRowsHeader: false,
            renderExpandableRow: (rowData, rowMeta) => {
              const exp = caratulasExportadores.data.filter((caratula) => caratula.caratula === rowData[0])
              const extraOptions = { 
                print: false, 
                filter: false, 
                pagination: false, 
                search: false,
                viewColumns: false,
                download: false,
                showResponsive: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                selectableRowsHideCheckboxes: true,
                selectableRowsHeader: false
              }
              return (
                <>
                  <tr>
                    <td colSpan={3}/>
                    <td colSpan={6}>
                      <MUIDataTable 
                        columns = {COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA} 
                        data = {exp} 
                        options = {extraOptions}
                      />
                    </td>
                  </tr>
                </>)
            }
          }
        },
        id: TABLA_COMUNICACIONES_INACTIVAS
      })
      //console.log('total', data.length)
      dispatch({ type: 'UPDATE_TOTAL_INACTIVAS', totalInactivas: data.length })
    }
  }
}

export function actualizarDatosExportadorPorCaratulaParaMuiTable (caratula) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_EXPORTADORES_POR_CARATULA
    })
    ComunicacionEmbarque.getExportadorPorCaratula(caratula).then(callback)
    function callback (data) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA,
          data: data,
          title: ``,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            print: false, 
            filter: false, 
            pagination: false, 
            search: false,
            viewColumns: false,
            download: false,
            showResponsive: true }
        },
        id: TABLA_EXPORTADORES_POR_CARATULA
      })
    }
  }
}

export function actualizarDatosCaratulasActivasParaMuiTable () {
  return (dispatch, getState) => {
    // Comunicaciones activas
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COMUNICACIONES_ACTIVAS
    })
    if (state.comunicacionEmbarque.filtroExportador !== null) {
      ComunicacionEmbarque.consultaCaratulasActivasConExportador(state.comunicacionEmbarque.filtroExportador).then(callback)
    } else { 
      ComunicacionEmbarque.getCaratulasActivas().then(callback)
    }
    async function callback (data) {
      const caratulasExportadores = await ComunicacionEmbarque.listadoExportadorCaratula()
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Detalle de Carátulas Activas',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COMUNICACIONES_ACTIVAS,
          data: data,
          title: `Detalle de Carátulas Activas`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false,
            pagination: false,
            expandableRows: true,
            expandableRowsOnClick: false,
            expandableRowsHeader: false,
            renderExpandableRow: (rowData, rowMeta) => {
              const exp = caratulasExportadores.data.filter((caratula) => caratula.caratula === rowData[0])
              const extraOptions = { 
                print: false, 
                filter: false, 
                pagination: false, 
                search: false,
                viewColumns: false,
                download: false,
                showResponsive: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                selectableRowsHideCheckboxes: false,
                selectableRowsHeader: false
              }
              return (
                <>
                  <tr>
                    <td colSpan={3}/>
                    <td colSpan={6}>
                      <MUIDataTable 
                        columns = {COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA} 
                        data = {exp} 
                        options = {extraOptions}
                      />
                    </td>
                  </tr>
                </>)
            }
          }
        },
        id: TABLA_COMUNICACIONES_ACTIVAS
      })
      dispatch({ type: 'UPDATE_TOTAL_ACTIVAS', totalActivas: data.length })
    }
  }
}

export function actualizarDatosCaratulasFinalizadasParaMuiTable () {
  return (dispatch, getState) => {
    // Comunicaciones finalizadas
    const state = getState()
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COMUNICACIONES_FINALIZADAS
    })
    if (state.comunicacionEmbarque.filtroExportador !== null) {
      ComunicacionEmbarque.consultaCaratulasFinalizadasConExportador(state.comunicacionEmbarque.filtroExportador).then(callback)
    } else {
      ComunicacionEmbarque.getCaratulasFinalizadas().then(callback)
    }
    async function callback (data) {
      const caratulasExportadores = await ComunicacionEmbarque.listadoExportadorCaratula()
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Detalle de Carátulas Finalizadas',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COMUNICACIONES_FINALIZADAS,
          data: data,
          title: `Detalle de Carátulas Finalizadas`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100],
            expandableRows: true,
            expandableRowsOnClick: false,
            expandableRowsHeader: false,
            renderExpandableRow: (rowData, rowMeta) => {
              const exp = caratulasExportadores.data.filter((caratula) => caratula.caratula === rowData[0])
              const extraOptions = { 
                print: false, 
                filter: false, 
                pagination: false, 
                search: false,
                viewColumns: false,
                download: false,
                showResponsive: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                selectableRowsHideCheckboxes: true,
                selectableRowsHeader: false
              }
              return (
                <>
                  <tr>
                    <td colSpan={3}/>
                    <td colSpan={6}>
                      <MUIDataTable 
                        columns = {COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA} 
                        data = {exp} 
                        options = {extraOptions}
                      />
                    </td>
                  </tr>
                </>)
            }
          }
        },
        id: TABLA_COMUNICACIONES_FINALIZADAS
      })
      dispatch({ type: 'UPDATE_TOTAL_FINALIZADAS', totalFinalizadas: data.length })
    }
  }
}

export function actualizarDatosCoemsParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COEMS
    })
    ComunicacionEmbarque.getCoemPorCaratula(id).then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'COEMs Activos',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}{<Tooltip title={'Agregar Coem'}><IconButton onClick={() => dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_COEM', estado: true })}><AddBoxIcon /></IconButton></Tooltip>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COEMS,
          data: data,
          title: `COEMs Activos`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100],
            showResponsive: true 
          }
        },
        id: TABLA_COEMS
      })
    }
  }
}

export function actualizarDatosCoemsFinalizadosParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COEMS_FINALIZADOS
    })
    ComunicacionEmbarque.getCoemPorCaratula(id).then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Coems',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COEMS_CERRADOS,
          data: data,
          title: ``,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 10, 
            rowsPerPageOptions: [10, 50], 
            showResponsive: true 
          }
        },
        id: TABLA_COEMS_FINALIZADOS
      })
    }
  }
}

export function actualizarDatosCoemsCerradosParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COEMS_CERRADOS
    })
    ComunicacionEmbarque.getCoemCerradosPorCaratula(id).then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Contenido de la carga - COEMs activos',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COEMS_CERRADOS,
          data: data,
          title: `Contenido de la carga - COEMs activos`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 10, 
            rowsPerPageOptions: [10, 50], 
            showResponsive: true 
          }
        },
        id: TABLA_COEMS_CERRADOS
      })
    }
  }
}

export function actualizarDatosCoemsAnuladosParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COEMS_ANULADOS
    })
    ComunicacionEmbarque.getCoemAnuladasPorCaratula(id).then(callback)
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'COEMs Anulados',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_LISTADO_COEMS_CERRADOS,
          data: data,
          title: `COEMs Anulados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 10, 
            rowsPerPageOptions: [10, 50], 
            showResponsive: true 
          }
        },
        id: TABLA_COEMS_ANULADOS
      })
    }
  }
}

export function actualizarDatosHistorialCaratulaParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COMUNICACIONES_HISTORIAL
    })
    ComunicacionEmbarque.getCaratula(id).then(consultaCaratula =>
      ComunicacionEmbarque.getHistorialCaratula(consultaCaratula.identificadorCaratula)
        .then(callback))
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Historial de Acciones',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}{<div />}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTORIAL,
          data: data,
          title: `Historial de Acciones`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 10, 
            rowsPerPageOptions: [10, 50], 
            showResponsive: true 
          }
        },
        id: TABLA_COMUNICACIONES_HISTORIAL
      })
    }
  }
}

export function actualizarDatosHistorialCoemsParaMuiTable (id) {
  return dispatch => {
    // Coems
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_COEM_HISTORIAL
    })
    ComunicacionEmbarque.getCoemId(id).then(consultaCoem =>
      ComunicacionEmbarque.getHistorialCoem(consultaCoem.identificadorAduana)
        .then(callback))
    function callback (data) {
      const customToolbar = () => <> { pdfCustomToolbarGenerator(
        'Historial de Acciones',
        data,
        COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT,
        'landscape')}{<div />}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_HISTORIAL,
          data: data,
          title: `Historial de Acciones`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { 
            customToolbar, 
            viewColumns: false, 
            rowsPerPage: 10, 
            rowsPerPageOptions: [10, 50], 
            showResponsive: true 
          }
        },
        id: TABLA_COEM_HISTORIAL
      })
    }
  }
}

export function getConsultaDatosCaratula (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CARATULA' })
    ComunicacionEmbarque.getCaratula(id)
      .then(consultaCaratula => {
        dispatch({ type: 'RECEIVE_CONSULTA_CARATULA', consultaCaratula })
      })
  }
}

export function consultaEstadosCoem (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_ESTADOS_COEM' })
    dispatch({ type: 'SET_REQUESTING_SOAP' })
    ComunicacionEmbarque.getCaratula(id)
      .then(consultaCaratula => {
        if (consultaCaratula !== null) {
          ComunicacionEmbarque.consultaEstadosCoem(consultaCaratula.identificadorCaratula)
            .then(consultaCoems => {
              console.log('consultaEstadosCoem', consultaCoems)
              if (!consultaCoems.error) {
                const dataConsulta = consultaCoems.data[0]
                const dataConsultaSub = dataConsulta.consultaEstadosCoem.substr(1, dataConsulta.consultaEstadosCoem.length - 2).split(',')
                console.log('Asi queda la consulta', dataConsultaSub)
                // esto no va
                // const dataConsultaSub1 = Array()
                // dataConsultaSub1[0] = '25040COEM000320X(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000321J(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000306M(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)'
                // const dataResultado = dataConsultaSub1[0].split('#')
                //
                const dataResultado = dataConsultaSub[2].split('#')
                
                if (dataResultado.length === 0) {
                  toast.error('No se encontraron estados de COEMs.')
                  return
                } else {
                  toast.success('Estados de COEMs consultados exitosamente.')
                  dispatch(estadoRegistro('9999', dataResultado, ''))
                  dispatch(updateStatusModal(true))
                  dataResultado.forEach((item) => {
                    console.log('itemId', item)
                  })
                }
              } else {
                toast.error('Error al consultar los estados de los COEMs.')
              }
              dispatch({ type: 'RECEIVE_CONSULTA_ESTADOS_COEM', consultaCoems })
              dispatch({ type: 'RESET_REQUESTING_SOAP' })
            })
        } else {
          toast.error('Error al consultar la carátula.')
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function consultaSolicitudes (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_SOLICITUDES' })
    dispatch({ type: 'SET_REQUESTING_SOAP' })
    ComunicacionEmbarque.getCaratula(id)
      .then(consultaCaratula => {
        if (consultaCaratula !== null) {
          ComunicacionEmbarque.consultaSolicitudes(consultaCaratula.identificadorCaratula)
            .then(consulta => {
              console.log('consultaSolicitudes', consulta)
              if (!consulta.error) {
                const dataConsulta = consulta.data[0]
                const dataConsultaSub = dataConsulta.consultaSolicitudes.substr(1, dataConsulta.consultaSolicitudes.length - 2).split(',')
                console.log('Asi queda la consulta', dataConsultaSub)
                // esto no va
                // const dataConsultaSub1 = Array()
                // dataConsultaSub1[0] = '25040COEM000320X(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000321J(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000306M(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)'
                // const dataResultado = dataConsultaSub1[0].split('#')
                //
                const dataResultado = dataConsultaSub[2].split('#')
                
                if (dataResultado.length === 0) {
                  toast.error('No se encontraron Solicitudes pendientes.')
                  return
                } else {
                  toast.success('Consulta realizada exitosamente.')
                  dispatch(estadoRegistro('9999', dataResultado, ''))
                  dispatch(updateStatusModal(true))
                  dataResultado.forEach((item) => {
                    console.log('itemId', item)
                  })
                }

              } else {
                toast.error('Error al realizar la consulta')
              }
              dispatch({ type: 'RECEIVE_CONSULTA_SOLICITUDES', consulta })
              dispatch({ type: 'RESET_REQUESTING_SOAP' })
            })
        } else {
          toast.error('Error al consultar la carátula.')
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function consultaNoAbordo (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_NO_ABORDO' })
    dispatch({ type: 'SET_REQUESTING_SOAP' })
    ComunicacionEmbarque.getCaratula(id)
      .then(consultaCaratula => {
        if (consultaCaratula !== null) {
          ComunicacionEmbarque.consultaNoAbordo(consultaCaratula.identificadorCaratula)
            .then(consultaNoAbordo => {
              console.log('consultaEstadosCoem', consultaNoAbordo)
              if (!consultaNoAbordo.error) {
                const dataConsulta = consultaNoAbordo.data[0]
                const dataConsultaSub = dataConsulta.consultaNoAbordo.substr(1, dataConsulta.consultaNoAbordo.length - 2).split(',')
                console.log('Asi queda la consulta', dataConsultaSub)
                // esto no va
                // const dataConsultaSub1 = Array()
                // dataConsultaSub1[0] = '25040COEM000320X(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000321J(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)#25040COEM000306M(RECHAZADA 1-Otros-CAMBIO DE GIRO, PASO AL GIRO 1)'
                // const dataResultado = dataConsultaSub1[0].split('#')
                //
                const dataResultado = dataConsultaSub[2].split('#')
                
                if (dataResultado.length === 0) {
                  toast.error('No se encontraron solicitudes de No Abordo.')
                  return
                } else {
                  toast.success('Consulta realizada exitosamente.')
                  dispatch(estadoRegistro('9999', dataResultado, ''))
                  dispatch(updateStatusModal(true))
                  dataResultado.forEach((item) => {
                    console.log('itemId', item)
                  })
                }

              } else {
                toast.error('Error al consultar las solicitudes de No Abordo.')
              }
              dispatch({ type: 'RECEIVE_CONSULTA_ESTADOS_COEM', consultaNoAbordo })
              dispatch({ type: 'RESET_REQUESTING_SOAP' })
            })
        } else {
          toast.error('Error al consultar la carátula.')
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function getConsultaCaratula (id, formChange) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CARATULA' })
    ComunicacionEmbarque.getCaratula(id)
      .then(passThrough(consultaCaratula => {
        dispatch({ type: 'RECEIVE_CONSULTA_CARATULA', consultaCaratula })
        dispatch(actualizarGiroSelecionado(consultaCaratula.giro))
        formChange('giro', consultaCaratula.giro)
        // formChange('nroViaje', consultaCaratula.nroViaje)
        formChange('buque', consultaCaratula.buque)
        formChange('cereal' , consultaCaratula.cereal)
        dispatch(setAceitero(consultaCaratula.aceitero))
        dispatch(actualizarExportadoresEnFormulario(consultaCaratula.id))
      }))
      // .then(passThroughAwait(
      //   updateEntidadAutocomplete(
      //     'buque', 'buque', 'buque', formChange)))
      .then(passThroughAwait(
        updateEntidadAutocomplete(
          'agencia_maritima', 'agencia', 'agenciaMaritimaRazonSocial', formChange)))
      .catch((error) => {
        console.log(error)
      })
  }
}

export function getConsultaHistorialCaratula (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_CARATULA' })
    ComunicacionEmbarque.getCaratula(id)
      .then(consultaCaratula => {
        ComunicacionEmbarque.getHistorialCaratula(consultaCaratula.identificadorCaratula)
          .then(response => {
            dispatch({ type: 'RECEIVE_HISTORIAL_CARATULA', response })
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export function getConsultaCoem (id, formChange) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_COEMS' })
    ComunicacionEmbarque.getCoemId(id)
      .then(passThrough(consultaCoem => {
        dispatch({ type: 'RECEIVE_CONSULTA_COEMS', consultaCoem })
        formChange('identificadorDeclaracion', consultaCoem.identificadorDeclaracion)
        formChange('peso', consultaCoem.peso)
        //formChange('item', consultaCoem.item)
        formChange('fechaEmbarque', (consultaCoem.fechaDeEmbarque !== null) ? moment(consultaCoem.fechaDeEmbarque).format('YYYY-MM-DD[T]HH:mm') : moment().format('YYYY-MM-DD[T]HH:mm'))
        formChange('cantidadReal', consultaCoem.pesoEmbarcado)
        formChange('cantidadReal2', consultaCoem.pesoEmbarcadoItem2)
        formChange('cantidadReal3', consultaCoem.pesoEmbarcadoItem3)
        formChange('cantidadReal4', consultaCoem.pesoEmbarcadoItem4) 
        dispatch(updateCierreCumplido(consultaCoem.cierreCumplido))
        formChange('cierreCumplidoSwitch', consultaCoem.cierreCumplido)
        formChange('exportador', consultaCoem.exportador)
        
        //exportador
      }))
      .catch((error) => {
        console.log(error)
      })
  }
}

export function getConsultaHistorialCoem (id) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_COEM' })
    ComunicacionEmbarque.getCoemId(id)
      .then(consultaCoem => {
        ComunicacionEmbarque.getHistorialCoem(consultaCoem.identificadorAduana)
          .then(response => {
            dispatch({ type: 'RECEIVE_HISTORIAL_COEM', response })
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

function updateEntidadAutocomplete (
  entidad, fieldName, attr, change) {
  return response => {
    //console.log(response[attr])
    return Autocomplete.directSearch(entidad, response[attr].trimEnd())
      .then(matches => {
        let match = matches && matches.shift()
        match = match || ''
        change(fieldName, match)
      })
  }
}

export function getCoemsPorCaratula (id, callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_CONSULTA_COEMS' })
    ComunicacionEmbarque.getCoemPorCaratula(id)
      .then(consultaCoem => {
        dispatch({ type: 'RECEIVE_CONSULTA_COEMS', consultaCoem })
        callback && callback(consultaCoem)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CONSULTA_COEMS',
        consultaCoem: null
      }))
  }
}

export function getGiros (callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_GIROS' })
    Giro.getGiros()
      .then(giros => {
        dispatch({ type: 'RECEIVE_GIROS', giros })
        callback && callback(giros)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_GIROS',
        giros: null
      }))
  }
}

export function getBuques (callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_BUQUES' })
    Buque.getBuques()
      .then(buques => {
        dispatch({ type: 'RECEIVE_BUQUES', buques })
        callback && callback(buques)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_BUQUES',
        buques: null
      }))
  }
}

export function actualizarGiroSelecionado (giro) {
  return dispatch => {
    dispatch({ type: 'REQUEST_ACTUALIZAR_GIRO', giro })
  }
}

export function setOpenDialog (estado) {
  return dispatch => {
    dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_CARATULA', estado })
  }
}

export function setOpenDialogCoem (estado) {
  return dispatch => {
    dispatch({ type: 'RECEIVE_MOSTRAR_DIALOG_ADD_COEM', estado })
  }
}

export function CargaUpdateEntities (entities, updater) {
  return (dispatch) => {
    return Autocomplete.searchSet(entities.searchSet)
      .then((response) => entities.fields.forEach(field =>
        updater(field, response.shift()[0]))
      )
  }
}

export function actualizarExportadorSelecionado (exportador) {
  return dispatch => {
    dispatch({ type: 'REQUEST_ACTUALIZAR_EXPORTADOR', exportador })
  }
}

export function submitUpdateCaratula () {
  return (dispatch, getState) => {
    const state = getState()
    const promises = []
    const caratulaExportador = state.comunicacionEmbarque.caratulaExportador
    const caratulaValues = getFormValues(FORM_ADD_CARATULA)(state)
    caratulaValues.buqueAceitero = state.comunicacionEmbarque.buqueAceitero
    if (caratulaValues.buqueAceitero) {
      caratulaValues.cereal = null
    }
    console.log('caratulaValues', caratulaValues)
    if (caratulaValues.buque) {
      if (caratulaValues.giro && caratulaValues.giro !== null) {
        if (caratulaValues.buque['imo'] !== null) {
          ComunicacionEmbarque.altaCaratula(caratulaValues)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_ALTA_CARATULA' })
              if (!saveStatus.error) {
                ComunicacionEmbarque.getUltimaCaratulaInactiva()
                  .then(caratula => {
                    caratulaExportador.forEach((exportador) => {
                      promises.push(ComunicacionEmbarque.agregarExportadorCaratula(caratula.id, parseEntityId(exportador)))
                    })
                    Promise.all(promises)
                      .then((data) => {
                        if (data.error) {
                          toast.error('Error al agregar exportadores a la Carátula')
                        }
                      })
                      .catch(error => {
                        console.log(error)
                      })
                })
                toast.success('Carátula ingresada exitosamente.')
                dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
                dispatch({ type: 'RESET_CARATULA_EXPORTADOR' })
                dispatch(setOpenDialog(false))
              } else {
                toast.error('Error al ingresar la Carátula.')
              }
            })
            .catch(() => {
              dispatch({ type: 'ERROR_ALTA_CARATULA' })
              toast.error('Error al ingresar la nueva Carátula.')
            })
        } else {
          toast.error('El buque seleccionado no posee un número de IMO válido.')
        }
      } else {
        toast.error('Debe seleccionar un Giro de amarre.')
      }
    } else {
      toast.error('No se puede realizar la operación porque la información es incompleta.')
    }
  }
}

export function submitActualizarCaratula () {
  return (dispatch, getState) => {
    const state = getState()
    const promises = []
    const caratulaExportador = state.comunicacionEmbarque.caratulaExportador
    const caratulaValues = getFormValues(FORM_EDICION_CARATULA)(state)
    caratulaValues.buqueAceitero = state.comunicacionEmbarque.buqueAceitero
    if (caratulaValues.buqueAceitero) {
      caratulaValues.cereal = null
    }
    const id = state.comunicacionEmbarque.consultaCaratula.id
    console.log('caratulaValues', caratulaValues, id)
    if (caratulaValues.buque) {
      if (caratulaValues.giro && caratulaValues.giro !== null) {
        if (caratulaValues.buque['imo'] !== null) {
          ComunicacionEmbarque.modificarCaratula(caratulaValues, id)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_MODIFICAR_CARATULA' })
              console.log('Modificar Caratula', saveStatus)
              if (!saveStatus.error) {
                if (caratulaExportador.length > 0) {
                  console.log('eliminando exportadores de la caratula', id)
                  ComunicacionEmbarque.eliminarAllExportadorCaratula(id)
                    .then(() => {
                      caratulaExportador.forEach((exportador) => {
                        promises.push(ComunicacionEmbarque.agregarExportadorCaratula(id, parseEntityId(exportador)))
                      })
                      Promise.all(promises)
                        .then((data) => {
                          if (data.error) {
                            toast.error('Error al agregar exportadores a la Carátula')
                          }
                        })
                        .catch(error => {
                          console.log(error)
                        })
                    })
                    .catch(error => {
                      console.log(error)
                    })
                }
                //TODO: actualizar el listado de exportadores x carátula
                toast.success('Carátula actualizada exitosamente.')
                dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
                dispatch(actualizarDatosCaratulasActivasParaMuiTable())
                dispatch({ type: 'RESET_CARATULA_EXPORTADOR' })
                dispatch(setOpenDialog(false))
              } else {
                toast.error('Error al modificar la Carátula.')
              }
            })
            .catch(() => {
              dispatch({ type: 'ERROR_MODIFICAR_CARATULA' })
              toast.error('Error al modificar la Carátula.')
            })
        } else {
          toast.error('El buque seleccionado no posee un número de IMO válido.')
        }
      } else {
        toast.error('Debe seleccionar un Giro/Muelle de amarre.')
      }
    } else {
      toast.error('No se puede realizar la operación porque la información es incompleta.')
    }
  }
}

export function eliminarCaratula (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.eliminarCaratula(id)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_ELIMINAR_CARATULA' })
          console.log('Eliminar Caratula', saveStatus)
          if (!saveStatus.error) {
            toast.success('Carátula eliminada exitosamente.')
            dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
            dispatch(setOpenDialog(false))
          } else {
            toast.error('Error al eliminar la Carátula.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_ELIMINAR_CARATULA' })
          toast.error('Error al eliminar la Carátula.')
        })
    } else {
      toast.error('No proporcionó un ID Válido.')
    }
  }
}

export function eliminarCoem (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          dispatch({ type: 'SET_REQUESTING_SOAP' })
          ComunicacionEmbarque.getCaratula(coem.caratula)
            .then((caratula) => {
              ComunicacionEmbarque.eliminarCoem(id)
                .then((saveStatus) => {
                  dispatch({ type: 'RECEIVE_ELIMINAR_COEM' })
                  console.log('Eliminar COEM', saveStatus)
                  if (!saveStatus.error) {
                    toast.success('COEM eliminado exitosamente.')
                    dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                    dispatch(agregarHistorial(caratula.identificadorCaratula, COEM, ELIMINAR_COEM))
                    dispatch(ultimaAccion(id, COEM, ELIMINAR_COEM))
                    dispatch(setOpenDialog(false))
                  } else {
                    toast.error('Error al eliminar el COEM.')
                  }
                })
                .catch(() => {
                  dispatch({ type: 'ERROR_ELIMINAR_COEM' })
                  toast.error('Error al eliminar el COEM.')
                })
            })
            dispatch({ type: 'RESET_REQUESTING_SOAP' })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_ELIMINAR_COEM' })
          toast.error('Error al eliminar el COEM.')
        })
    } else {
      toast.error('No proporcionó un ID Válido.')
    }
  }
}

export function eliminarCode (id) {
  return (dispatch) => {
    if (id !== null) {
      ComunicacionEmbarque.deleteCode(id)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_ELIMINAR_CODE' })
          console.log('Eliminar Code', saveStatus)
          if (!saveStatus.error) {
            toast.success('CODE eliminado exitosamente.')
            dispatch(actualizarDatosCaratulasFinalizadasParaMuiTable())
          } else {
            toast.error('Error al eliminar el CODE de la Carátula.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_ELIMINAR_CODE' })
          toast.error('Error al eliminar el CODE de la Carátula.')
        })
    } else {
      toast.error('No proporcionó un ID Válido.')
    }
  }
}

export function cambiarEstadoTablas (value) {
  return (dispatch) => {
    dispatch({ type: 'SET_ESTADO_TABLAS', estadoTablas: value })
  }
}

export function actualizarFiltrosExportadores (id) {
  return (dispatch, getState) => {
    const state = getState()
    const estadoTablas = state.comunicacionEmbarque.estadoTablas
    if (estadoTablas !== null) {
      switch (estadoTablas) {
        case 1:
          ComunicacionEmbarque.listadoExportadoresCaratulasInactivas()
            .then((exportadores) => {
              if (!exportadores.error) {
                dispatch({ type: 'ACTUALIZAR_EXPORTADORES', exportadores })
                console.log('Actualizar Exportadores', exportadores)
              } else {
                toast.error('Error al actualizar los Exportadores.')
              }
            })
            .catch(() => {
              console.log('ERROR_ACTUALIZAR_EXPORTADORES', estadoTablas)
            })
          break;
        case 2:
          ComunicacionEmbarque.listadoExportadoresCaratulasActivas()
            .then((exportadores) => {
              if (!exportadores.error) {
                dispatch({ type: 'ACTUALIZAR_EXPORTADORES', exportadores })
                console.log('Actualizar Exportadores', exportadores)
              } else {
                toast.error('Error al actualizar los Exportadores.')
              }
            })
            .catch(() => {
              console.log('ERROR_ACTUALIZAR_EXPORTADORES', estadoTablas)
            })
          break;
        case 3:
          ComunicacionEmbarque.listadoExportadoresCaratulasFinalizadas()
            .then((exportadores) => {
              if (!exportadores.error) {
                dispatch({ type: 'ACTUALIZAR_EXPORTADORES', exportadores })
                console.log('Actualizar Exportadores', exportadores)
              } else {
                toast.error('Error al actualizar los Exportadores.')
              }
            })
            .catch(() => {
              console.log('ERROR_ACTUALIZAR_EXPORTADORES', estadoTablas)
            })
          break;
        default:
          console.log('No se reconoce el estado de tablas', estadoTablas)
          break;
      }    
    }
  }
}

export function actualizarEstadoFiltroExportadores (exportador, razonSocial) {
  return (dispatch, getState) => {
    const state = getState()
    console.log('actualizando filtros de exportador', exportador)
    dispatch({
      type: 'UPDATE_ESTADO_FILTRADO_EXPORTADORES',
      exportador,
      razonSocial
    })
    if (state.comunicacionEmbarque.estadoTablas === 1) {
      dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
    } else if (state.comunicacionEmbarque.estadoTablas === 2) {
      dispatch(actualizarDatosCaratulasActivasParaMuiTable())
    } else if (state.comunicacionEmbarque.estadoTablas === 3) {
      dispatch(actualizarDatosCaratulasFinalizadasParaMuiTable())
    }
  }
}

export function resetEstadoFiltroExportadores () {
  return (dispatch, getState) => {
    const state = getState()
    console.log('reseteando filtros')
    dispatch({
      type: 'RESET_ESTADO_FILTRADO_EXPORTADORES'
    })
    if (state.comunicacionEmbarque.estadoTablas === 1) {
      dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
    } else if (state.comunicacionEmbarque.estadoTablas === 2) {
      dispatch(actualizarDatosCaratulasActivasParaMuiTable())
    } else if (state.comunicacionEmbarque.estadoTablas === 3) {
      dispatch(actualizarDatosCaratulasFinalizadasParaMuiTable())
    }
  }
}

export function actualizarEstadosCaratulas () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CARATULAS_CON_ESTADO' })
    ComunicacionEmbarque.getCaratulasActivasConEstado()
      .then((caratulasConEstado) => {
        if (!caratulasConEstado.error) {
          dispatch({ type: 'ACTUALIZAR_CARATULAS_CON_ESTADO', caratulasConEstado })
          console.log('Actualizar Caratulas con Estado', caratulasConEstado)
        } else {
          toast.error('Error al actualizar elestado de las caratulas.')
        }
      })
      .catch(() => {
        console.log('ERROR_ACTUALIZAR_CARATULAS_CON_ESTADO')
      })
  }
}

export function regresarCoemEstadoAnterior (id) {
  return (dispatch) => {
    if (id !== null) {
      ComunicacionEmbarque.regresarEstadoAnteriorCoem(id)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_REGRESAR_ESTADO_ANTERIOR_COEM' })
          console.log('Actualizar COEM', saveStatus)
          if (!saveStatus.error) {
            toast.success('COEM actualizado exitosamente.')
            ComunicacionEmbarque.getCoemId(id)
              .then(consultaCoem => {
                dispatch(actualizarDatosCoemsParaMuiTable(consultaCoem.caratula))
              })
          } else {
            toast.error('Error al actualizar el COEM.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_REGRESAR_ESTADO_ANTERIOR_COEM' })
          toast.error('Error al actualizar el COEM.')
        })
    } else {
      toast.error('No proporcionó un ID Válido.')
    }
  }
}

export function regresarCaratulaEstadoInactiva (id) {
  return (dispatch) => {
    if (id !== null) {
      // Verificar si la carátula tiene COEMs activos
      ComunicacionEmbarque.getCoemPorCaratula(id)
        .then(coems => {
          if (coems.length > 0) {
            coems.forEach((coem) => {
              console.log('coem', coem)
              ComunicacionEmbarque.updateCoemAnulada(coem.id)
                .then((saveStatus) => {
                  dispatch({ type: 'ACTUALIZAR_COEM' })
                  if (saveStatus.error) {
                    toast.error('No se puede regresar la Carátula porque tiene COEMs activos y no pueden ser anulados.')
                    return
                  }
                })
                .catch(() => {
                  toast.error('Error al anular Coems.')
                })
            })
          } 
          // Si no tiene COEMs activos, proceder a regresar la carátula
          ComunicacionEmbarque.regresarCaratulaEstadoInactiva(id)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_ACTUALIZAR_CARATULA' })
              console.log('Actualizar Caratula', saveStatus)
              if (!saveStatus.error) {
                toast.success('CARÁTULA actualizada exitosamente.')
                dispatch(actualizarDatosCaratulasActivasParaMuiTable())
              } else {
                toast.error('Error al actualizar Carátula.')
              }
            })
            .catch(() => {
              dispatch({ type: 'ERROR_ACTUALIZAR_CARATULA' })
              toast.error('Error al actualizar Carátula.')
            })
        })
    } else {
      toast.error('No proporcionó un ID Válido.')
    }
  }
}

export function submitUpdateCoems () {
  return (dispatch, getState) => {
    const state = getState()
    const coemValues = getFormValues(FORM_COEM_ADD)(state)
    coemValues.agenciaMaritima = state.comunicacionEmbarque.consultaCaratula.agenciaMaritimaCuit
    coemValues.caratula = state.comunicacionEmbarque.consultaCaratula.id
    console.log('coemValues', coemValues)
    if (coemValues && coemValues.exportador && coemValues.exportador !== null) {
      ComunicacionEmbarque.altaCoem(coemValues)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_ALTA_COEM' })
          console.log('Alta de Coem', saveStatus)
          if (!saveStatus.error) {
            toast.success('Coem ingresado exitosamente.')
            dispatch(actualizarDatosCoemsParaMuiTable(state.comunicacionEmbarque.consultaCaratula.id))
            dispatch(setOpenDialogCoem(false))
          } else {
            toast.error('Error al ingresar la Coem.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_ALTA_COEM' })
          toast.error('Error al ingresar el nuevo Coem.')
        })
    } else {
      toast.error('No se puede realizar la operación porque la información es incompleta.')}
  }
}

export function submitActualizarCoems (id) {
  return (dispatch, getState) => {
    const state = getState()
    const coemValues = getFormValues(FORM_EDICION_COEM)(state)
    coemValues.caratula = state.comunicacionEmbarque.consultaCaratula.id
    console.log('coemValues', coemValues)
    console.log('resultado', (coemValues.peso + coemValues.peso * 4/100)/1000)
    // Validar que el peso embarcado no supere el 4% del peso declarado 
    if (coemValues && (coemValues.cantidadReal <= ((coemValues.peso + coemValues.peso * 4/100))/1000)) {
      ComunicacionEmbarque.modificarCoem(coemValues)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_MODIFICAR_COEM' })
          console.log('Modificar Coem', saveStatus)
          if (!saveStatus.error) {
            toast.success('Coem actualizado exitosamente.')
            dispatch(actualizarDatosCoemsParaMuiTable(state.comunicacionEmbarque.consultaCaratula.id))
            dispatch(setOpenDialogCoem(false))
            dispatch({ type: 'RESET_CONSULTA_COEM' })
          } else {
            toast.error('Error al modificar Coem.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_MODIFICAR_COEM' })
          toast.error('Error al modificar el Coem.')
        })
    } else {
      toast.error('El peso embarcado no puede superar en mas del 4% del peso declarado.')
    }
  }
}

export function registrarCaratula (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      dispatch({ type: 'SET_REQUESTING_SOAP' })
      ComunicacionEmbarque.getCaratulaInactiva(id)
        .then((caratula) => {
          console.log('esta es la caratula', caratula)
          // Verificar fecha de arribo entre 5 y 96 hs antes de la fecha actual
          if (caratula.fechaDeArribo >= moment().add(5, 'h').format('YYYY-MM-DD HH:mm') &&
            caratula.fechaDeArribo <= moment().add(96, 'h').format('YYYY-MM-DD HH:mm')) {
            ComunicacionEmbarque.registrarCaratula(caratula.imo, caratula.codigoLugarOperativo, caratula.fechaDeArribo,
              caratula.fechaDeZarpada, caratula.nombreBuque, caratula.nroViaje)
              .then((saveStatus) => {
                dispatch({ type: 'RECEIVE_REGISTRAR_CARATULA' })
                console.log('Registro de Caratula', saveStatus)
                if (!saveStatus.error) {
                  // toast.success('Carátula registrada exitosamente.')
                  const dataCaratula = saveStatus[0].registrarCaratula.substr(1, saveStatus[0].registrarCaratula.length - 2).split(',')
                  console.log('Asi queda', dataCaratula)
                  if (parseInt(dataCaratula[0]) > 0) {
                    // console.log('Correcto')
                    // console.log('devolucion', parseInt(dataCaratula[1]))
                    if (parseInt(dataCaratula[1]) === 0) {
                      // Guardar la respuesta de aduana
                      // Devolver respuesta a Mensaje
                      // console.log('Se registro')
                      // console.log(dataCaratula[1])
                      // console.log(dataCaratula[2])
                      // console.log(dataCaratula[3])
                      const identificador = dataCaratula[3].split(':')
                      console.log(identificador[1].substr(0, identificador[1].length - 1))
                      const codigoAduana = dataCaratula[1]
                      const mensajeAduana = dataCaratula[2]
                      const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                      // Guardar idAduana
                      ComunicacionEmbarque.updateCaratulaIdAduana(id, idAduana)
                        .then((saveStatus) => {
                          dispatch({ type: 'ACTUALIZAR_CARATULA' })
                          console.log('Actualizo el identificador', saveStatus)
                          dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
                          dispatch(actualizarDatosCaratulasActivasParaMuiTable())
                          toast.success('Carátula registrada exitosamente!!!')
                          // Verificar si tiene COEMs anulados para reactivarlos
                          // esta situacion puede pasar si se registra una caratula, se generan coems y luego se anula la caratula
                          ComunicacionEmbarque.getCoemAnuladasPorCaratula(id)
                            .then(coems => {
                              if (coems.length > 0) {
                                coems.forEach((coem) => {
                                  console.log('coem para activar', coem)
                                  ComunicacionEmbarque.updateCoemActiva(coem.id)
                                    .then((saveStatus) => {
                                      console.log('Se activa el coem', saveStatus)
                                      dispatch({ type: 'ACTUALIZAR_COEM' })
                                      if (saveStatus.error) {
                                        toast.error('No se pudieron activar todos los COEMs.')
                                      }
                                    })
                                    .catch(() => {
                                      toast.error('Error al activar Coems.')
                                    })
                                })
                              } 
                            })
                        })
                      dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                      dispatch(updateStatusModal(true))
                      dispatch(agregarHistorial(idAduana, CARATULA, REGISTRAR_CARATULA))
                      dispatch(ultimaAccion(id, CARATULA, REGISTRAR_CARATULA))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    } else {
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      dispatch(estadoRegistro(dataCaratula[1], dataCaratula[2]))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  } else {
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    toast.info('No se pudo registrar la Carátula en Aduana.')
                    console.log('Error al registrar')
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.error('Error al registrar la Carátula.')
                }
              })
          } else {
            dispatch({ type: 'RESET_REQUESTING_SOAP' })
            toast.error('La Fecha de Arribo debe ser entre 5 y 96 horas posterior al registro en Aduana')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
          toast.error('Error al buscar la Carátula.')
        })
    } else {
      toast.error('Debe seleccionar un Giro de amarre.')
    }
  }
}

export function rectificarCaratula (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      dispatch({ type: 'SET_REQUESTING_SOAP' })
      ComunicacionEmbarque.getCaratulaActiva(id)
        .then((caratula) => {
          console.log('esta es la caratula', caratula)
          // Verificar fecha de arribo entre 5 y 96 hs antes de la fecha actual
          if (caratula.fechaDeArribo >= moment().add(5, 'h').format('YYYY-MM-DD HH:mm') &&
            caratula.fechaDeArribo <= moment().add(96, 'h').format('YYYY-MM-DD HH:mm')) {
            ComunicacionEmbarque.rectificarCaratula(caratula.imo, caratula.codigoLugarOperativo, caratula.fechaDeArribo,
              caratula.fechaDeZarpada, caratula.nombreBuque, caratula.identificadorCaratula)
              .then((saveStatus) => {
                dispatch({ type: 'RECEIVE_RECTIFICAR_CARATULA' })
                console.log('Rectificar Caratula', saveStatus)
                if (!saveStatus.error) {
                  const dataCaratula = saveStatus[0].rectificarCaratula.substr(1, saveStatus[0].rectificarCaratula.length - 2).split(',')
                  console.log('Asi queda', dataCaratula)
                  if (parseInt(dataCaratula[0]) > 0) {
                    console.log('Correcto')
                    console.log('devolucion', parseInt(dataCaratula[1]))
                    if (parseInt(dataCaratula[1]) === 0) {
                      // Devolver respuesta a Mensaje
                      console.log('Se rectifico')
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      console.log(dataCaratula[3])
                      const identificador = dataCaratula[3].split(':')
                      console.log(identificador[1].substr(0, identificador[1].length - 1))
                      const codigoAduana = dataCaratula[1]
                      const mensajeAduana = dataCaratula[2]
                      // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                      dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                      dispatch(updateStatusModal(true))
                      dispatch(agregarHistorial(caratula.identificadorCaratula, CARATULA, RECTIFICAR_CARATULA))
                      dispatch(ultimaAccion(id, CARATULA, RECTIFICAR_CARATULA))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    } else {
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      dispatch(estadoRegistro(dataCaratula[1], dataCaratula[2]))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  } else {
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    toast.info('No se pudo rectificar la Carátula en Aduana.')
                    console.log('Error al registrar')
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.error('Error al rectificar la Carátula.')
                }
              })
          } else {
            dispatch({ type: 'RESET_REQUESTING_SOAP' })
            toast.error('La Fecha de Arribo debe ser entre 5 y 96 horas posterior al registro en Aduana')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
          toast.error('Error al buscar la Carátula.')
        })
    } else {
      toast.error('Debe seleccionar un Giro de amarre.')
    }
  }
}

export function solicitarCambioBuque (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      dispatch({ type: 'SET_REQUESTING_SOAP' })
      ComunicacionEmbarque.getCaratulaActiva(id)
        .then((caratula) => {
          console.log('esta es la caratula', caratula)
          ComunicacionEmbarque.solicitarCambioBuque(caratula.identificadorCaratula, caratula.imo, caratula.nombreBuque)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_SOLICITAR_CAMBIO_BUQUE' })
              console.log('Solicitar Cambio Buque', saveStatus)
              if (!saveStatus.error) {
                const dataCaratula = saveStatus[0].solicitarCambioBuque.substr(1, saveStatus[0].solicitarCambioBuque.length - 2).split(',')
                console.log('Asi queda', dataCaratula)
                if (parseInt(dataCaratula[0]) > 0) {
                  console.log('Correcto')
                  console.log('devolucion', parseInt(dataCaratula[1]))
                  if (parseInt(dataCaratula[1]) === 0) {
                    // Devolver respuesta a Mensaje
                    console.log('Se solicito')
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    console.log(dataCaratula[3])
                    const identificador = dataCaratula[3].split(':')
                    console.log(identificador[1].substr(0, identificador[1].length - 1))
                    const codigoAduana = dataCaratula[1]
                    const mensajeAduana = dataCaratula[2]
                    // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                    dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                    dispatch(updateStatusModal(true))
                    dispatch(agregarHistorial(caratula.identificadorCaratula, CARATULA, SOLICITAR_CAMBIO_BUQUE))
                    dispatch(ultimaAccion(id, CARATULA, SOLICITAR_CAMBIO_BUQUE))
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  } else {
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    dispatch(estadoRegistro(dataCaratula[1], dataCaratula.join()))
                    dispatch(updateStatusModal(true))
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.info('No se pudo Solicitar Cambio Buque en Aduana.')
                  console.log('Error al solicitar')
                }
              } else {
                dispatch({ type: 'RESET_REQUESTING_SOAP' })
                toast.error('Error al Solicitar Cambio Buque.')
              }
            })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
          toast.error('Error al buscar la Carátula.')
        })
    }
  }
}

export function solicitarCambioFechas (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      const motivo = window.prompt('Ingrese el motivo del cambio de fechas', '')
      console.log(motivo)
      if (motivo !== '') {
        dispatch({ type: 'SET_REQUESTING_SOAP' })
        ComunicacionEmbarque.getCaratulaActiva(id)
          .then((caratula) => {
            console.log('esta es la caratula', caratula)
            ComunicacionEmbarque.solicitarCambioFechas(caratula.identificadorCaratula, caratula.fechaDeArribo,
              caratula.fechaDeZarpada, motivo)
              .then((saveStatus) => {
                dispatch({ type: 'RECEIVE_SOLICITAR_CAMBIO_FECHAS' })
                console.log('Solicitar Cambio Buque', saveStatus)
                if (!saveStatus.error) {
                  const dataCaratula = saveStatus[0].solicitarCambioFechas.substr(1, saveStatus[0].solicitarCambioFechas.length - 2).split(',')
                  console.log('Asi queda', dataCaratula)
                  if (parseInt(dataCaratula[0]) > 0) {
                    console.log('Correcto')
                    console.log('devolucion', parseInt(dataCaratula[1]))
                    if (parseInt(dataCaratula[1]) === 0) {
                      // Devolver respuesta a Mensaje
                      console.log('Se solicito')
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      console.log(dataCaratula[3])
                      const identificador = dataCaratula[3].split(':')
                      console.log(identificador[1].substr(0, identificador[1].length - 1))
                      const codigoAduana = dataCaratula[1]
                      const mensajeAduana = dataCaratula[2]
                      // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                      dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                      dispatch(agregarHistorial(caratula.identificadorCaratula, CARATULA, SOLICITAR_CAMBIO_FECHAS))
                      dispatch(ultimaAccion(id, CARATULA, SOLICITAR_CAMBIO_FECHAS))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    } else {
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      dispatch(estadoRegistro(dataCaratula[1], dataCaratula.join()))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  } else {
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    toast.info('No se pudo Solicitar Cambio de Fechas en Aduana.')
                    console.log('Error al solicitar')
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.error('Error al Solicitar Cambio de Fechas.')
                }
              })
          })
          .catch(() => {
            dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
            dispatch({ type: 'RESET_REQUESTING_SOAP' })
            toast.error('Error al buscar la Carátula.')
          })
      } else {
        toast.info(`No seleccionó un motivo válido.`)
      }
    }
  }
}

export function solicitarAnulacionCoem (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          if (coem.identificadorAduana !== null) {
            dispatch({ type: 'SET_REQUESTING_SOAP' })
            ComunicacionEmbarque.solicitarAnulacionCoem(coem.identificadorCaratula, coem.identificadorAduana)
              .then((saveStatus) => {
                dispatch({ type: 'RECEIVE_SOLICITAR_ANULACION_COEM' })
                console.log('Solicitar anulacion de COEM', saveStatus)
                if (!saveStatus.error && saveStatus.length > 0) {
                  const dataCOEM = saveStatus[0].solicitarAnulacionCoem.substr(1, saveStatus[0].solicitarAnulacionCoem.length - 2).split(',')
                  console.log('Asi queda', dataCOEM)
                  if (parseInt(dataCOEM[0]) > 0) {
                    console.log('Correcto')
                    console.log('devolucion', parseInt(dataCOEM[1]))
                    if (parseInt(dataCOEM[1]) === 0) {
                      // Devolver respuesta a Mensaje
                      console.log('Se solito anulacion de COEM')
                      console.log(dataCOEM[1])
                      console.log(dataCOEM[2])
                      console.log(dataCOEM[3])
                      const identificador = dataCOEM[3].split(':')
                      console.log(identificador[1].substr(0, identificador[1].length - 1))
                      const codigoAduana = dataCOEM[1]
                      const mensajeAduana = dataCOEM[2]
                      // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                      // Anular COEM en BD
                      ComunicacionEmbarque.updateCoemAnulada(id)
                        .then((saveStatus) => {
                          dispatch({ type: 'ACTUALIZAR_COEM' })
                          ComunicacionEmbarque.getCaratula(coem.caratula)
                            .then((caratula) => {
                              dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                            })
                          toast.success('COEM anulado exitosamente!!!')
                        })
                      dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                      dispatch(agregarHistorial(coem.identificadorAduana, COEM, SOLICITAR_ANULACION_COEM))
                      dispatch(ultimaAccion(id, COEM, SOLICITAR_ANULACION_COEM))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    } else {
                      console.log(dataCOEM[1])
                      console.log(dataCOEM[2])
                      dispatch(estadoRegistro(dataCOEM[1], dataCOEM.join()))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  } else {
                    toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    console.log('Error al solicitar anulacion de COEM')
                  }
                } else {
                  toast.error('Error al intentar solicitar anulacion de COEM.')
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                }
              })
          } else {
            toast.error('El COEM no está registrado en Aduana.')
          }
        })
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function solicitarNoABordo (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      const motivo = window.prompt('Ingrese el motivo de la solicitud del No a Bordo', '')
      console.log(motivo)
      if (motivo !== '') {
        ComunicacionEmbarque.getCoemId(id)
          .then((coem) => {
            console.log('este es el coem', coem)
            if (coem.identificadorAduana !== null) {
              dispatch({ type: 'SET_REQUESTING_SOAP' })
              ComunicacionEmbarque.solicitarNoABordo(coem.identificadorCaratula, coem.identificadorAduana,
                coem.identificadorDeclaracion, motivo)
                .then((saveStatus) => {
                  dispatch({ type: 'RECEIVE_SOLICITAR_NO_A_BORDO' })
                  console.log('Solicitar No a Bordo de COEM', saveStatus)
                  if (!saveStatus.error && saveStatus.length > 0) {
                    const dataCOEM = saveStatus[0].solicitarNoABordo.substr(1, saveStatus[0].solicitarNoABordo.length - 2).split(',')
                    console.log('Asi queda', dataCOEM)
                    if (parseInt(dataCOEM[0]) > 0) {
                      console.log('Correcto')
                      console.log('devolucion', parseInt(dataCOEM[1]))
                      if (parseInt(dataCOEM[1]) === 0) {
                        // Devolver respuesta a Mensaje
                        console.log('Se solicito no a bordo de COEM')
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        console.log(dataCOEM[3])
                        const identificador = dataCOEM[3].split(':')
                        console.log(identificador[1].substr(0, identificador[1].length - 1))
                        const codigoAduana = dataCOEM[1]
                        const mensajeAduana = dataCOEM[2]
                        // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                        // Anular COEM en BD
                        ComunicacionEmbarque.updateCoemAnulada(id)
                          .then((saveStatus) => {
                            dispatch({ type: 'ACTUALIZAR_COEM' })
                            ComunicacionEmbarque.getCaratula(coem.caratula)
                              .then((caratula) => {
                                dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                              })
                            toast.success('COEM anulado exitosamente!!!')
                          })
                        dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                        dispatch(agregarHistorial(coem.identificadorAduana, COEM, SOLICITAR_NO_A_BORDO))
                        dispatch(ultimaAccion(id, COEM, SOLICITAR_NO_A_BORDO))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      } else {
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        dispatch(estadoRegistro(dataCOEM[1], dataCOEM.join()))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      }
                    } else {
                      toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      console.log('Error al solicitar no a bordo de COEM')
                    }
                  } else {
                    toast.error('Error al intentar solicitar no a bordo de COEM.')
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  }
                })
            } else {
              toast.error('El COEM no está registrado en Aduana.')
            }
          })
      } else {
        toast.info(`No ingresó un motivo válido.`)
      }
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function solicitarCambioLOT (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      dispatch({ type: 'SET_REQUESTING_SOAP' })
      ComunicacionEmbarque.getCaratulaActiva(id)
        .then((caratula) => {
          console.log('esta es la caratula', caratula)
          ComunicacionEmbarque.solicitarCambioLOT(caratula.identificadorCaratula, caratula.codigoLugarOperativo)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_SOLICITAR_CAMBIO_LOT' })
              console.log('Solicitar Cambio LOT', saveStatus)
              if (!saveStatus.error) {
                const dataCaratula = saveStatus[0].solicitarCambioLot.substr(1, saveStatus[0].solicitarCambioLot.length - 2).split(',')
                console.log('Asi queda', dataCaratula)
                if (parseInt(dataCaratula[0]) > 0) {
                  console.log('Correcto')
                  console.log('devolucion', parseInt(dataCaratula[1]))
                  if (parseInt(dataCaratula[1]) === 0) {
                    // Devolver respuesta a Mensaje
                    console.log('Se solicito')
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    console.log(dataCaratula[3])
                    const identificador = dataCaratula[3].split(':')
                    console.log(identificador[1].substr(0, identificador[1].length - 1))
                    const codigoAduana = dataCaratula[1]
                    const mensajeAduana = dataCaratula[2]
                    // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                    dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                    dispatch(updateStatusModal(true))
                    dispatch(agregarHistorial(caratula.identificadorCaratula, CARATULA, SOLICITAR_CAMBIO_LOT))
                    dispatch(ultimaAccion(id, CARATULA, SOLICITAR_CAMBIO_LOT))
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  } else {
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    dispatch(estadoRegistro(dataCaratula[1], dataCaratula.join()))
                    dispatch(updateStatusModal(true))
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.info('No se pudo Solicitar Cambio de Lugar Operativo en Aduana.')
                  console.log('Error al solicitar')
                }
              } else {
                dispatch({ type: 'RESET_REQUESTING_SOAP' })
                toast.error('Error al Solicitar Cambio de Lugar Operativo.')
              }
            })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
          toast.error('Error al buscar la Carátula.')
        })
    }
  }
}

export function registrarCoem (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          if (coem.identificadorAduana === null) {
            dispatch({ type: 'SET_REQUESTING_SOAP' })
            ComunicacionEmbarque.getCaratula(coem.caratula)
              .then((caratula) => {
                ComunicacionEmbarque.registrarCoem(caratula.identificadorCaratula, coem.identificadorDeclaracion, caratula.agenciaMaritimaCuit,
                  coem.codigoEmbalaje, coem.peso)
                  .then((saveStatus) => {
                    dispatch({ type: 'RECEIVE_REGISTRAR_COEM' })
                    console.log('Registro de COEM', saveStatus)
                    if (!saveStatus.error && saveStatus.length > 0) {
                      const dataCOEM = saveStatus[0].registrarCoem.substr(1, saveStatus[0].registrarCoem.length - 2).split(',')
                      console.log('Asi queda', dataCOEM)
                      if (parseInt(dataCOEM[0]) > 0) {
                        console.log('Correcto')
                        console.log('devolucion', parseInt(dataCOEM[1]))
                        if (parseInt(dataCOEM[1]) === 0) {
                          // Guardar la respuesta de aduana
                          // Devolver respuesta a Mensaje
                          console.log('Se registro COEM')
                          console.log(dataCOEM[1])
                          console.log(dataCOEM[2])
                          console.log(dataCOEM[3])
                          const identificador = dataCOEM[3].split(':')
                          console.log(identificador[1].substr(0, identificador[1].length - 1))
                          const codigoAduana = dataCOEM[1]
                          const mensajeAduana = dataCOEM[2]
                          const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                          // Guardar idAduana
                          ComunicacionEmbarque.updateCoemIdAduana(id, idAduana)
                            .then((saveStatus) => {
                              dispatch({ type: 'ACTUALIZAR_COEM' })
                              console.log('Actualizando el identificador del coem', saveStatus)
                              dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                              toast.success('COEM registrado exitosamente!!!')
                              // Preguntar si desea cerrar el COEM en Aduana
                              if (window.confirm('¿Desea también CERRAR el COEM en Aduana?')) {
                                dispatch(cerrarCoem(id))
                              }
                            })
                          dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                          dispatch(agregarHistorial(idAduana, COEM, REGISTRAR_COEM))
                          dispatch(ultimaAccion(id, COEM, REGISTRAR_COEM))
                          dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        } else {
                          console.log(dataCOEM[1])
                          console.log(dataCOEM[2])
                          dispatch(estadoRegistro(dataCOEM[1], dataCOEM[2]))
                          dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        }
                      } else {
                        toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        console.log('Error al registrar COEM')
                      }
                    } else {
                      toast.error('Error al intentar registrar el COEM.')
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  })
              })
          } else {
            toast.error('El COEM ya se encuentra registrado en Aduana.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_COEM' })
          toast.error('Error al buscar el COEM.')
        })
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function rectificarCoem (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          dispatch({ type: 'SET_REQUESTING_SOAP' })
          ComunicacionEmbarque.getCaratula(coem.caratula)
            .then((caratula) => {
              ComunicacionEmbarque.rectificarCoem(caratula.identificadorCaratula, coem.identificadorAduana, coem.identificadorDeclaracion,
                caratula.agenciaMaritimaCuit, coem.codigoEmbalaje, coem.peso)
                .then((saveStatus) => {
                  dispatch({ type: 'RECEIVE_RECTIFICAR_COEM' })
                  console.log('Rectificar COEM', saveStatus)
                  if (!saveStatus.error && saveStatus.length > 0) {
                    const dataCOEM = saveStatus[0].rectificarCoem.substr(1, saveStatus[0].rectificarCoem.length - 2).split(',')
                    console.log('Asi queda', dataCOEM)
                    if (parseInt(dataCOEM[0]) > 0) {
                      console.log('Correcto')
                      console.log('devolucion', parseInt(dataCOEM[1]))
                      if (parseInt(dataCOEM[1]) === 0) {
                        // Devolver respuesta a Mensaje
                        console.log('Se rectifico COEM')
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        console.log(dataCOEM[3])
                        const identificador = dataCOEM[3].split(':')
                        console.log(identificador[1].substr(0, identificador[1].length - 1))
                        const codigoAduana = dataCOEM[1]
                        const mensajeAduana = dataCOEM[2]
                        // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                        // // Guardar idAduana
                        // ComunicacionEmbarque.updateCoemIdAduana(id, idAduana)
                        //   .then((saveStatus) => {
                        //     dispatch({ type: 'ACTUALIZAR_COEM' })
                        //     console.log('Actualizando el identificador del coem', saveStatus)
                        //     dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                        //     toast.success('COEM registrado exitosamente!!!')
                        //   })
                        dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                        dispatch(agregarHistorial(coem.identificadorAduana, COEM, RECTIFICAR_COEM))
                        dispatch(ultimaAccion(id, COEM, RECTIFICAR_COEM))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      } else {
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        dispatch(estadoRegistro(dataCOEM[1], dataCOEM[2]))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      }
                    } else {
                      toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      console.log('Error al rectificar COEM')
                    }
                  } else {
                    toast.error('Error al intentar rectificar el COEM.')
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  }
                })
            })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_COEM' })
          toast.error('Error al buscar el COEM.')
        })
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function anularCaratula (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCaratulaActiva(id)
        .then((caratula) => {
          console.log('esta es la caratula', caratula)
          ComunicacionEmbarque.anularCaratula(caratula.identificadorCaratula)
            .then((saveStatus) => {
              dispatch({ type: 'RECEIVE_ANULAR_CARATULA' })
              console.log('Anular Caratula', saveStatus)
              if (!saveStatus.error) {
                const dataCaratula = saveStatus[0].anularCaratula.substr(1, saveStatus[0].anularCaratula.length - 2).split(',')
                console.log('Asi queda', dataCaratula)
                if (parseInt(dataCaratula[0]) > 0) {
                  console.log('Correcto')
                  console.log('devolucion', parseInt(dataCaratula[1]))
                  if (parseInt(dataCaratula[1]) === 0) {
                    console.log('Se registro')
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    console.log(dataCaratula[3])
                    const codigoAduana = dataCaratula[1]
                    const mensajeAduana = dataCaratula[2]
                    // Guardar anulacion
                    ComunicacionEmbarque.updateCaratulaAnulada(id)
                      .then((saveStatus) => {
                        dispatch({ type: 'ACTUALIZAR_CARATULA' })
                        dispatch(actualizarDatosCaratulasActivasParaMuiTable())
                        toast.success('Carátula anulada exitosamente.')
                      })
                    dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                    dispatch(agregarHistorial(caratula.identificadorCaratula, CARATULA, ANULAR_CARATULA))
                    dispatch(ultimaAccion(id, CARATULA, ANULAR_CARATULA))
                    dispatch(updateStatusModal(true))
                  } else {
                    console.log(dataCaratula[1])
                    console.log(dataCaratula[2])
                    dispatch(estadoRegistro(dataCaratula[1], dataCaratula[2]))
                    dispatch(updateStatusModal(true))
                  }
                } else {
                  console.log('Error al anular')
                }
              } else {
                toast.error('Error al anular la Carátula.')
              }
            })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          toast.error('Error al buscar la Carátula.')
        })
    } else {
      toast.error('Debe seleccionar un Giro de amarre.')
    }
  }
}

export function anularCoem (id) {
  // Sin terminar
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          dispatch({ type: 'SET_REQUESTING_SOAP' })
          ComunicacionEmbarque.getCaratula(coem.caratula)
            .then((caratula) => {
              ComunicacionEmbarque.anularCoem(caratula.identificadorCaratula, coem.identificadorAduana)
                .then((saveStatus) => {
                  dispatch({ type: 'RECEIVE_ANULAR_COEM' })
                  console.log('Anular de COEM', saveStatus)
                  if (!saveStatus.error && saveStatus.length > 0) {
                    const dataCOEM = saveStatus[0].anularCoem.substr(1, saveStatus[0].anularCoem.length - 2).split(',')
                    console.log('Asi queda', dataCOEM)
                    if (parseInt(dataCOEM[0]) > 0) {
                      console.log('Correcto')
                      console.log('devolucion', parseInt(dataCOEM[1]))
                      if (parseInt(dataCOEM[1]) === 0) {
                        // Guardar la respuesta de aduana
                        // Devolver respuesta a Mensaje
                        console.log('Se anulo COEM')
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        console.log(dataCOEM[3])
                        const identificador = dataCOEM[3].split(':')
                        console.log(identificador[1].substr(0, identificador[1].length - 1))
                        const codigoAduana = dataCOEM[1]
                        const mensajeAduana = dataCOEM[2]
                        // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                        // Guardar idAduana
                        ComunicacionEmbarque.updateCoemAnulada(id)
                          .then((saveStatus) => {
                            dispatch({ type: 'ACTUALIZAR_COEM' })
                            dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                            toast.success('COEM anulado exitosamente!!!')
                          })
                        dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                        dispatch(agregarHistorial(coem.identificadorAduana, COEM, ANULAR_COEM))
                        dispatch(ultimaAccion(id, COEM, ANULAR_COEM))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      } else {
                        console.log(dataCOEM[1])
                        console.log(dataCOEM[2])
                        dispatch(estadoRegistro(dataCOEM[1], dataCOEM[2]))
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      }
                    } else {
                      toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                      console.log('Error al anular COEM')
                    }
                  } else {
                    toast.error('Error al intentar anular el COEM.')
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  }
                })
            })
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_COEM' })
          toast.error('Error al buscar el COEM.')
        })
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function cerrarCoem (id) {
  return (dispatch, getState) => {
    if (id !== null) {
      ComunicacionEmbarque.getCoemId(id)
        .then((coem) => {
          console.log('este es el coem', coem)
          if (coem.identificadorAduana !== null) {
            dispatch({ type: 'SET_REQUESTING_SOAP' })
            ComunicacionEmbarque.getCaratula(coem.caratula)
              .then((caratula) => {
                ComunicacionEmbarque.cerrarCoem(caratula.identificadorCaratula, coem.identificadorAduana)
                  .then((saveStatus) => {
                    dispatch({ type: 'RECEIVE_CERRAR_COEM' })
                    console.log('Cerrar COEM', saveStatus)
                    if (!saveStatus.error && saveStatus.length > 0) {
                      const dataCOEM = saveStatus[0].cerrarCoem.substr(1, saveStatus[0].cerrarCoem.length - 2).split(',')
                      console.log('Asi queda', dataCOEM)
                      if (parseInt(dataCOEM[0]) > 0) {
                        console.log('Correcto')
                        console.log('devolucion', parseInt(dataCOEM[1]))
                        if (parseInt(dataCOEM[1]) === 0) {
                          // Guardar la respuesta de aduana
                          // Devolver respuesta a Mensaje
                          console.log('Se cerro COEM')
                          console.log(dataCOEM[1])
                          console.log(dataCOEM[2])
                          console.log(dataCOEM[3])
                          const identificador = dataCOEM[3].split(':')
                          console.log(identificador[1].substr(0, identificador[1].length - 1))
                          const codigoAduana = dataCOEM[1]
                          const mensajeAduana = dataCOEM[2]
                          // const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                          // Guardar
                          ComunicacionEmbarque.updateCoemCerrada(id)
                            .then((saveStatus) => {
                              dispatch({ type: 'ACTUALIZAR_COEM' })
                              dispatch(actualizarDatosCoemsParaMuiTable(caratula.id))
                              toast.success('COEM cerrado exitosamente!!!')
                            })
                          dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCOEM[3]))
                          dispatch(agregarHistorial(coem.identificadorAduana, COEM, CERRAR_COEM))
                          dispatch(ultimaAccion(id, COEM, CERRAR_COEM))
                          dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        } else {
                          console.log(dataCOEM[1])
                          console.log(dataCOEM[2])
                          dispatch(estadoRegistro(dataCOEM[1], dataCOEM[2]))
                          dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        }
                      } else {
                        toast.info(`Código ${dataCOEM[1]} ${dataCOEM[2]}`, { autoClose: false })
                        dispatch({ type: 'RESET_REQUESTING_SOAP' })
                        console.log('Error al cerrar COEM')
                      }
                    } else {
                      toast.error('Error al intentar cerrar el COEM.')
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  })
              })
          } else {
            toast.error('El COEM no está registrado en Aduana.')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_COEM' })
          toast.error('Error al buscar el COEM.')
        })
    } else {
      toast.error('Debe seleccionar un COEM.')
    }
  }
}

export function solicitarCierreCargaGranel (id) {
  return (dispatch, getState) => {
    const state = getState()
    const caratulaValues = getFormValues(FORM_EDICION_CARATULA)(state)
    console.log('caratulaValues', caratulaValues, id)
    if (id !== null) {
      dispatch({ type: 'SET_REQUESTING_SOAP' })
      let fechaZarpada = null
      if (caratulaValues !== null && caratulaValues !== undefined && caratulaValues.fechaZarpada) {
        fechaZarpada = caratulaValues.fechaZarpada
      } else {
        // Convendria mandar la fecha actual
        fechaZarpada = moment(Date.now()).format('DD-MM-YYYY HH:mm:ss')
        //fechaZarpada = state.comunicacionEmbarque.consultaCaratula.fechaDeZarpada
      }
      ComunicacionEmbarque.updateCaratulaFechaDeZarpada(fechaZarpada, id)
        .then((saveStatus) => {
          dispatch({ type: 'RECEIVE_MODIFICAR_CARATULA' })
          console.log('Modificar Caratula', saveStatus)
          if (!saveStatus.error) {
            ComunicacionEmbarque.solicitarCierreCargaGranel(id)
              .then((saveStatus) => {
                dispatch({ type: 'RECEIVE_SOLICITAR_CIERRE_CARGA_GRANEL' })
                console.log('solicitar cierre carga granel', saveStatus)
                if (!saveStatus.error) {
                  const dataCaratula = saveStatus[0].solicitarCierreCargaGranel.substr(1, saveStatus[0].solicitarCierreCargaGranel.length - 2).split(',')
                  console.log('Asi queda', dataCaratula)
                  if (parseInt(dataCaratula[0]) > 0) {
                    console.log('Correcto')
                    console.log('devolucion', parseInt(dataCaratula[1]))
                    if (parseInt(dataCaratula[1]) === 0) {
                      // Devolver respuesta a Mensaje
                      console.log('Se registro')
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      console.log(dataCaratula[3])
                      const identificador = dataCaratula[3].split(':')
                      console.log(identificador[1].substr(0, identificador[1].length - 1))
                      const codigoAduana = dataCaratula[1]
                      const mensajeAduana = dataCaratula[2]
                      const idAduana = identificador[1].substr(0, identificador[1].length - 1)
                      // Guardar idAduana en code
                      ComunicacionEmbarque.altaCode(id, idAduana, caratulaValues.peso)
                        .then((saveStatus) => {
                          dispatch({ type: 'ALTA_CODE' })
                          console.log('Alta del code', saveStatus)
                          dispatch(actualizarDatosCaratulasInactivasParaMuiTable())
                          dispatch(actualizarDatosCaratulasActivasParaMuiTable())
                          dispatch(actualizarDatosCaratulasFinalizadasParaMuiTable())
                          toast.success('Solicitud de cierre de carga generado exitosamente!!!')
                        })
                      dispatch(estadoRegistro(codigoAduana, mensajeAduana, dataCaratula[3]))
                      dispatch(agregarHistorial(state.comunicacionEmbarque.consultaCaratula.identificadorCaratula, CARATULA, SOLICITAR_CIERRE_CARGA_GRANEL))
                      dispatch(ultimaAccion(id, CARATULA, SOLICITAR_CIERRE_CARGA_GRANEL))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    } else {
                      console.log(dataCaratula[1])
                      console.log(dataCaratula[2])
                      dispatch(estadoRegistro(dataCaratula[1], dataCaratula[2]))
                      dispatch(updateStatusModal(true))
                      dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    }
                  } else {
                    dispatch({ type: 'RESET_REQUESTING_SOAP' })
                    toast.info('No se pudo Solicitar el Cierre de Carga a Granel en Aduana.')
                    console.log('Error al registrar')
                  }
                } else {
                  dispatch({ type: 'RESET_REQUESTING_SOAP' })
                  toast.error('Error al Solicitar Cierre de Carga a Granel.')
                }
              })
          } else {
            dispatch({ type: 'RESET_REQUESTING_SOAP' })
            toast.error('No se pudo actualizar la fecha de zarpada en la Carátula')
          }
        })
        .catch(() => {
          dispatch({ type: 'ERROR_BUSQUEDA_CARATULA' })
          dispatch({ type: 'RESET_REQUESTING_SOAP' })
          toast.error('Error al modificar la Carátula.')
        })
    } else {
      toast.error('Debe contener un Id válido.')
    }
  }
}

export function obtenerTotales (id, formChange) {
  return (dispatch) => {
    return ComunicacionEmbarque.getPesosTotales(id)
      .then(result => {
        console.log('Result', result)
        if (result) {
          dispatch({
            type: 'CONSULTA_PESO_TOTALES_EMBARCADOS',
            pesoTotalEmbarcado: result.consultaPesoTotalEmbarcado
          })
          formChange('peso', result.consultaPesoTotalEmbarcado)
        }
      })
  }
}

export function agregarHistorial (identificadorAduana, tipo, accion) {
  return (dispatch) => {
    dispatch({ type: 'AGREGAR_HISTORIAL' })
    switch (tipo) {
      case ('CARATULA'):
        ComunicacionEmbarque.addHistoryCaratula(identificadorAduana, accion)
          .then(result => {
            console.log('Result', result)
            if (result) {
              dispatch({ type: 'ADD_HISTORIAL_CARATULA' })
            }
          })
        break
      case ('COEM'):
        ComunicacionEmbarque.addHistoryCoem(identificadorAduana, accion)
          .then(result => {
            console.log('Result', result)
            if (result) {
              dispatch({ type: 'ADD_HISTORIAL_COEM' })
            }
          })
        break
      default:
        throw new Error('tipo no soportado')
    }
  }
}

export function ultimaAccion (id, tipo, accion) {
  return (dispatch) => {
    dispatch({ type: 'ULTIMA_ACCION' })
    switch (tipo) {
      case ('CARATULA'):
        ComunicacionEmbarque.ultimaAccionCaratula(id, accion)
          .then(result => {
            console.log('Result', result)
            if (result) {
              dispatch({ type: 'ADD_ACCION_CARATULA' })
            }
          })
        break
      case ('COEM'):
        ComunicacionEmbarque.ultimaAccionCoem(id, accion)
          .then(result => {
            console.log('Result', result)
            if (result) {
              dispatch({ type: 'ADD_ACCION_COEM' })
            }
          })
        break
      default:
        throw new Error('tipo no soportado')
    }
  }
}

export function estadoRegistro (codigoAduana, mensajeAduana, idAduana = null) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_ESTADO_REGISTRO',
      codigoAduana,
      mensajeAduana,
      idAduana
    })
  }
}

export function closeModal () {
  return (dispatch) => {
    dispatch(updateStatusModal(false))
    dispatch({ type: 'RESET_ESTADO_REGISTRO' })
  }
}

export function updateStatusModal (status) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_STATUS_MODAL',
      status
    })
  }
}

export function updateCierreCumplido (newValue) {
  return (dispatch) => {
    return dispatch({ type: 'UPDATE_CIERRE_CUMPLIDO', newValue })
  }
}

export function showToast (message, id, title, error = false) {
  return dispatch => {
    const onClose = () => {
      dispatch({
        type: 'CLOSE_TOAST',
        id: id
      })
    }
    dispatch({
      type: 'OPEN_TOAST',
      id: id,
      show: true,
      error: error,
      title: title,
      message: message,
      onClose: onClose
    })
  }
}

export function actualizarExportador (tipo) {
  return (dispatch, getState) => {
    const state = getState()
    let formValues = null
    if (tipo === 'ADD') {
      formValues = getFormValues(FORM_ADD_CARATULA)(state)
    } else if (tipo === 'EDIT') {
      formValues = getFormValues(FORM_EDICION_CARATULA)(state)
    } else {
      throw new Error('Tipo no soportado')
    }
    console.log(formValues)
    if (formValues && formValues.exportador) {
      const exportador = formValues.exportador
      dispatch({ type: 'RECEIVE_CARATULA_EXPORTADOR', exportador })
    }
  }
}

export function actualizarExportadoresEnFormulario (caratula) {
  return (dispatch, getState) => {
    ComunicacionEmbarque.consultaExportadorCaratula(caratula)
      .then((result) => {
        console.log('exportador', result)
        if (result.data && result.data.length > 0) {
          result.data.forEach(data => {
            console.log('exportador', data.exportador)
            const exportador = data.razonSocial + ' - ' + data.exportador

            dispatch({ type: 'RECEIVE_CARATULA_EXPORTADOR', exportador })
          })
        }
      })
  }
}

export function sacarExportador (caratula, exportador) {
  return (dispatch) => {
    console.log(caratula, exportador)
    if (caratula && exportador) {
      dispatch({ type: 'ELIMINAR_CARATULA_EXPORTADOR', exportador })
      console.log('exp', parseEntityId(exportador))
      ComunicacionEmbarque.eliminarExportadorCaratula(caratula, parseEntityId(exportador))
    }
  }
}

export function updateListaExportadoresSeleccionados (exportador) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_LISTA_EXPORTADORES_SELECCIONADOS', exportador })
  }
}

export function changeBuqueAceitero () {
  return (dispatch) => {
    dispatch({ type: 'CHANGE_ESTADO_BUQUE_ACEITERO' })
  }
}

export function setAceitero (aceitero) {
  return (dispatch) => {
    dispatch({ type: 'SET_ESTADO_BUQUE_ACEITERO', aceitero })
  }
}

export function resetCaratulaExportador () {
  return (dispatch) => {
    dispatch({ type: 'RESET_CARATULA_EXPORTADOR' })
  }
}